import React from 'react';
import ApexCharts from 'react-apexcharts';

const PieChartComponentGroupLeader = ({ groupLeaderChartDataPie }) => {
    // console.log("groupLeaderChartDataPies",groupLeaderChartDataPie)
    // Function to generate colors dynamically based on score ranges
    const generateColor = (averageScore) => {
        if (averageScore >= 0 && averageScore <= 24.9) return "#ED0530";
        if (averageScore >= 25 && averageScore <= 27.9) return "#F46983";
        if (averageScore >= 28 && averageScore <= 29.9) return "#FF7800";
        if (averageScore >= 29 && averageScore <= 30.9) return "#FFAE66";
        if (averageScore >= 31 && averageScore <= 32.9) return "#73C272";
        return "#489547";
    };

    // Map to colors, series, and labels for the pie chart
    const colors = groupLeaderChartDataPie.map(item => generateColor(item.total_score));
    const series = groupLeaderChartDataPie.map(item => item.total_score); // Scores for each zone
    const labels = groupLeaderChartDataPie.map(item => `Zone: ${item.zone_code}`); // Labels for each zone

    // Define options for the pie chart
    const options = {
        chart: {
            type: 'pie',
            height: 350,
        },
        labels: labels,
        colors: colors,
        dataLabels: {
            enabled: true,
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
                colors: ['#FFFFFF'],
                textShadow: 'none',
            },
            dropShadow: {
                enabled: false,
            },
            formatter: function (val, opts) {
                return opts.w.config.series[opts.seriesIndex].toFixed(2); // Show score without '%'
            }
        },
        
        legend: {
            show: false,
            position: 'bottom'
        },
        tooltip: {
            y: {
                formatter: (value) => value.toFixed(2) // Format tooltip without '%'
            }
        }
    };

    return (
        <div>
            <ApexCharts options={options} series={series} type="pie" width="100%" height={350} />
        </div>
    );
};

export default PieChartComponentGroupLeader;
